import React from "react";
import {GenericLayout} from "../layout/GenericLayout";

export const NotAuthorizedPage = () => {
    return <GenericLayout navbar={<>&nbsp;</>}>
        <p>Not authorized</p>
    </GenericLayout>
}